// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics_analytics_container__Ji8sF {
  width: 100%;
  height: 100%;
  border: 1px solid var(--sb-border-color);
  border-left: none;
  border-top: none;
  padding: 19px;
}
@media screen and (max-width: 1850px) {
  .analytics_analytics_container__Ji8sF {
    padding: 19px 10px;
  }
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF {
    border: none;
  }
}
.analytics_analytics_container__Ji8sF .analytics_plan__lge4N {
  border-radius: 12px;
  border: 1px solid var(--re-border-color);
  display: flex;
  flex-wrap: wrap;
  padding: 15px 18px 20px;
}
@media (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_plan__lge4N {
    height: 189px;
  }
}
.analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_bland__XEcb2 {
  width: 60%;
}
.analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_bland__XEcb2 .analytics_bland_icon__lp6ZH {
  display: flex;
}
.analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_bland__XEcb2 span {
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 7px;
}
.analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_bland__XEcb2 .analytics_brand_title__MnhEz {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-left: 6px;
}
.analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_bland__XEcb2 .analytics_brand_description__YgAci {
  font-size: 12px;
  text-align: left;
  font-weight: 500;
  line-height: 14px;
}
.analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_option__hh3vd {
  width: 40%;
  display: inline-block;
}
.analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_option__hh3vd .analytics_brand_label__zZAWU {
  width: 100%;
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: right;
}
.analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_option__hh3vd select {
  width: 214px;
  height: 42px;
  margin-top: 15px;
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_option__hh3vd select {
    width: 100%;
    margin-right: 0;
    margin-top: 10px;
  }
}
@media screen and (max-width: 1600px) {
  .analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_option__hh3vd select {
    width: 160px;
    max-width: 160px;
    float: right;
  }
}
@media (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_bland__XEcb2,
  .analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_option__hh3vd {
    width: 100%;
  }
  .analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_option__hh3vd {
    margin-top: 13px;
  }
  .analytics_analytics_container__Ji8sF .analytics_plan__lge4N .analytics_option__hh3vd .analytics_brand_label__zZAWU {
    float: left;
    margin-left: 5px;
  }
}
.analytics_analytics_container__Ji8sF .analytics_data_range__VtiMA {
  margin-top: 18px;
  border-radius: 12px;
  border: 1px solid var(--re-border-color);
  display: flex;
  flex-wrap: wrap;
  padding: 20px 18px 20px;
}
.analytics_analytics_container__Ji8sF .analytics_data_range__VtiMA .analytics_footer__nMYQ0 {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-top: 25px;
  gap: 9px;
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_data_range__VtiMA .analytics_footer__nMYQ0 {
    flex-direction: column;
  }
  .analytics_analytics_container__Ji8sF .analytics_data_range__VtiMA .analytics_footer__nMYQ0 button {
    width: 100% !important;
    left: 0px;
  }
}
.analytics_analytics_container__Ji8sF .analytics_data_range__VtiMA .analytics_option__hh3vd {
  width: 50%;
  padding-right: 5px;
  padding-left: 5px;
  display: inline-block;
}
.analytics_analytics_container__Ji8sF .analytics_data_range__VtiMA .analytics_option__hh3vd .analytics_label__9Ejjt {
  width: 100%;
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}
.analytics_analytics_container__Ji8sF .analytics_data_range__VtiMA .analytics_option__hh3vd input {
  width: 100%;
  height: 42px;
  margin-top: 5px;
  background-color: var(--re-select-dark-bg);
  border-radius: 12px;
  border: 1px solid transparent;
  color: var(--font-dark-color);
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  padding: 11px 20px 10px 16px;
  margin-top: 17px;
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_data_range__VtiMA .analytics_option__hh3vd input {
    width: 100%;
    margin-right: 0;
    margin-top: 10px;
  }
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc {
  width: 100%;
  height: 145px;
  background-color: var(--sb-bg-color);
  border-radius: 12px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 18px;
  padding: 10px;
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc {
    height: 241px;
  }
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh,
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse {
  width: calc((100% - 4px) / 2);
  height: 100%;
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh,
  .analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse {
    width: 100%;
    height: calc((100% - 4px) / 2);
  }
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh {
  border-radius: 12px;
  background: var(--re-data-left-bg);
  padding: 13px 17px 19px 18px;
  margin-right: 4px;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh .analytics_data_label__-YCzC {
  width: 100%;
  height: auto;
  display: flex;
  margin-bottom: 3px;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh .analytics_data_label__-YCzC span {
  color: #ffa329;
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh .analytics_data_label__-YCzC .analytics_left_rate__oPhGl {
  width: auto;
  height: 24px;
  background: var(--re-rate-bg);
  border-radius: 8px;
  display: flex;
  margin-left: auto;
  padding: 4px 3.27px 4px 4px;
  align-items: center;
  gap: 4px;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh .analytics_data_label__-YCzC .analytics_left_rate__oPhGl span {
  color: #ff6a55;
  font-family: Red Hat Display;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.15px;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh .analytics_capacity__DbDXO {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh .analytics_capacity__DbDXO {
    font-size: 26px;
  }
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh .analytics_progress__20\\+nb {
  width: 100%;
  height: 10px;
  background-color: var(--re-progress-bg);
  border-radius: 32px;
  margin-top: 12px;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_left__tpIRh .analytics_progress__20\\+nb div {
  height: 100%;
  background: linear-gradient(221deg, #ea50bf -27.22%, #ffa329 76.94%), linear-gradient(279deg, #3a37d1 -27.51%, #ea50bf 89.56%), #d9d9d9;
  border-radius: 32px;
  transition: all ease-out 0.3s;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse {
  padding: 13px 17px 19px 18px;
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse div {
    margin-bottom: 6px;
  }
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse .analytics_data_label__-YCzC {
  width: 100%;
  height: auto;
  display: flex;
  margin-bottom: 16px;
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse .analytics_data_label__-YCzC {
    margin-bottom: 12px;
  }
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse .analytics_data_label__-YCzC span {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse .analytics_data_label__-YCzC .analytics_left_rate__oPhGl {
  width: auto;
  height: 24px;
  background: var(--re-rate-bg);
  border-radius: 8px;
  display: flex;
  margin-left: auto;
  padding: 4px 3.27px 4px 4px;
  align-items: center;
  gap: 4px;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse .analytics_data_label__-YCzC .analytics_left_rate__oPhGl span {
  color: #ff6a55;
  font-family: Red Hat Display;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.15px;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse .analytics_today__om66y {
  color: #7c7c7d;
  font-family: Red Hat Display;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse .analytics_capacity__DbDXO {
  color: var(--font-color);
  font-family: Red Hat Display;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_data_value__3x3Yc .analytics_data_used__z3fse .analytics_capacity__DbDXO {
    font-size: 26px;
  }
}
.analytics_analytics_container__Ji8sF .analytics_horizontal__vyJz4 {
  width: 100%;
  height: 1px;
  background-color: var(--re-horizontal-bg);
  margin-top: 19px;
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_horizontal__vyJz4 {
    display: none;
  }
}
@media screen and (max-width: 781px) {
  .analytics_analytics_container__Ji8sF .analytics_proxy_container__I2E-2 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layouts/analytics/analytics.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AACF;AACE;EARF;IASI,kBAAA;EAEF;AACF;AAAE;EAZF;IAaI,YAAA;EAGF;AACF;AADE;EACE,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AAGJ;AADI;EAPF;IAQI,aAAA;EAIJ;AACF;AAFI;EACE,UAAA;AAIN;AAFM;EACE,aAAA;AAIR;AADM;EACE,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAGR;AAAM;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAER;AACM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AACR;AAGI;EACE,UAAA;EACA,qBAAA;AADN;AAGM;EACE,WAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AADR;AAIM;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AAFR;AAIQ;EALF;IAMI,WAAA;IACA,eAAA;IACA,gBAAA;EADR;AACF;AAGQ;EAXF;IAYI,YAAA;IACA,gBAAA;IACA,YAAA;EAAR;AACF;AAII;EACE;;IAEE,WAAA;EAFN;EAKI;IACE,gBAAA;EAHN;EAKM;IACE,WAAA;IACA,gBAAA;EAHR;AACF;AAQE;EACE,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AANJ;AAQI;EACE,aAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,QAAA;AANN;AAQM;EAPF;IAQI,sBAAA;EALN;EAOM;IACE,sBAAA;IACA,SAAA;EALR;AACF;AASI;EACE,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AAPN;AASM;EACE,WAAA;EACA,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAPR;AAUM;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,0CAAA;EACA,mBAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AARR;AAUQ;EAhBF;IAiBI,WAAA;IACA,eAAA;IACA,gBAAA;EAPR;AACF;AAYE;EACE,WAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAVJ;AAYI;EAVF;IAWI,aAAA;EATJ;AACF;AAWI;;EAEE,6BAAA;EACA,YAAA;AATN;AAWM;EALF;;IAMI,WAAA;IACA,8BAAA;EAPN;AACF;AAUI;EACE,mBAAA;EACA,kCAAA;EACA,4BAAA;EACA,iBAAA;AARN;AAUM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AARR;AAUQ;EACE,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AARV;AAWQ;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;AATV;AAWU;EACE,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AATZ;AAcM;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAZR;AAcQ;EARF;IASI,eAAA;EAXR;AACF;AAcM;EACE,WAAA;EACA,YAAA;EACA,uCAAA;EACA,mBAAA;EACA,gBAAA;AAZR;AAcQ;EACE,YAAA;EACA,uIAAA;EAEA,mBAAA;EACA,6BAAA;AAbV;AAkBI;EACE,4BAAA;AAhBN;AAkBM;EACE;IACE,kBAAA;EAhBR;AACF;AAmBM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAjBR;AAmBQ;EANF;IAOI,mBAAA;EAhBR;AACF;AAkBQ;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhBV;AAmBQ;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;AAjBV;AAmBU;EACE,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAjBZ;AAsBM;EACE,cAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AApBR;AAuBM;EACE,wBAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AArBR;AAuBQ;EARF;IASI,eAAA;EApBR;AACF;AAyBE;EACE,WAAA;EACA,WAAA;EACA,yCAAA;EACA,gBAAA;AAvBJ;AAyBI;EANF;IAOI,aAAA;EAtBJ;AACF;AA0BI;EADF;IAEI,aAAA;EAvBJ;AACF","sourcesContent":[".analytics_container {\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--sb-border-color);\n  border-left: none;\n  border-top: none;\n  padding: 19px;\n\n  @media screen and (max-width: 1850px) {\n    padding: 19px 10px;\n  }\n\n  @media screen and (max-width: 781px) {\n    border: none;\n  }\n\n  .plan {\n    border-radius: 12px;\n    border: 1px solid var(--re-border-color);\n    display: flex;\n    flex-wrap: wrap;\n    padding: 15px 18px 20px;\n\n    @media (max-width: 781px) {\n      height: 189px;\n    }\n\n    .bland {\n      width: 60%;\n\n      .bland_icon {\n        display: flex;\n      }\n\n      span {\n        color: var(--font-dark-color);\n        font-family: Red Hat Display;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        margin-top: 7px;\n      }\n\n      .brand_title {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        margin-left: 6px;\n      }\n\n      .brand_description {\n        font-size: 12px;\n        text-align: left;\n        font-weight: 500;\n        line-height: 14px;\n      }\n    }\n\n    .option {\n      width: 40%;\n      display: inline-block;\n\n      .brand_label {\n        width: 100%;\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        text-align: right;\n      }\n\n      select {\n        width: 214px;\n        height: 42px;\n        margin-top: 15px;\n\n        @media screen and (max-width: 781px) {\n          width: 100%;\n          margin-right: 0;\n          margin-top: 10px;\n        }\n\n        @media screen and (max-width: 1600px) {\n          width: 160px;\n          max-width: 160px;\n          float: right;\n        }\n      }\n    }\n\n    @media (max-width: 781px) {\n      .bland,\n      .option {\n        width: 100%;\n      }\n\n      .option {\n        margin-top: 13px;\n\n        .brand_label {\n          float: left;\n          margin-left: 5px;\n        }\n      }\n    }\n  }\n\n  .data_range {\n    margin-top: 18px;\n    border-radius: 12px;\n    border: 1px solid var(--re-border-color);\n    display: flex;\n    flex-wrap: wrap;\n    padding: 20px 18px 20px;\n\n    .footer {\n      display: flex;\n      justify-content: flex-end;\n      width: 100%;\n      padding-top: 25px;\n      gap: 9px;\n\n      @media screen and (max-width: 781px) {\n        flex-direction: column;\n\n        button {\n          width: 100% !important;\n          left: 0px;\n        }\n      }\n    }\n\n    .option {\n      width: 50%;\n      padding-right: 5px;\n      padding-left: 5px;\n      display: inline-block;\n\n      .label {\n        width: 100%;\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 14px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n        text-align: left;\n      }\n\n      input {\n        width: 100%;\n        height: 42px;\n        margin-top: 5px;\n        background-color: var(--re-select-dark-bg);\n        border-radius: 12px;\n        border: 1px solid transparent;\n        color: var(--font-dark-color);\n        font-family: Red Hat Display;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n        padding: 11px 20px 10px 16px;\n        margin-top: 17px;\n\n        @media screen and (max-width: 781px) {\n          width: 100%;\n          margin-right: 0;\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n\n  .data_value {\n    width: 100%;\n    height: 145px;\n    background-color: var(--sb-bg-color);\n    border-radius: 12px;\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: 18px;\n    padding: 10px;\n\n    @media screen and (max-width: 781px) {\n      height: 241px;\n    }\n\n    .data_left,\n    .data_used {\n      width: calc((100% - 4px) / 2);\n      height: 100%;\n\n      @media screen and (max-width: 781px) {\n        width: 100%;\n        height: calc((100% - 4px) / 2);\n      }\n    }\n\n    .data_left {\n      border-radius: 12px;\n      background: var(--re-data-left-bg);\n      padding: 13px 17px 19px 18px;\n      margin-right: 4px;\n\n      .data_label {\n        width: 100%;\n        height: auto;\n        display: flex;\n        margin-bottom: 3px;\n\n        span {\n          color: #ffa329;\n          font-family: Red Hat Display;\n          font-size: 15px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: normal;\n        }\n\n        .left_rate {\n          width: auto;\n          height: 24px;\n          background: var(--re-rate-bg);\n          border-radius: 8px;\n          display: flex;\n          margin-left: auto;\n          padding: 4px 3.27px 4px 4px;\n          align-items: center;\n          gap: 4px;\n\n          span {\n            color: #ff6a55;\n            font-family: Red Hat Display;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 16px;\n            letter-spacing: -0.15px;\n          }\n        }\n      }\n\n      .capacity {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 36px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n\n        @media screen and (max-width: 781px) {\n          font-size: 26px;\n        }\n      }\n\n      .progress {\n        width: 100%;\n        height: 10px;\n        background-color: var(--re-progress-bg);\n        border-radius: 32px;\n        margin-top: 12px;\n\n        div {\n          height: 100%;\n          background: linear-gradient(221deg, #ea50bf -27.22%, #ffa329 76.94%),\n            linear-gradient(279deg, #3a37d1 -27.51%, #ea50bf 89.56%), #d9d9d9;\n          border-radius: 32px;\n          transition: all ease-out 0.3s;\n        }\n      }\n    }\n\n    .data_used {\n      padding: 13px 17px 19px 18px;\n\n      @media screen and (max-width: 781px) {\n        div {\n          margin-bottom: 6px;\n        }\n      }\n\n      .data_label {\n        width: 100%;\n        height: auto;\n        display: flex;\n        margin-bottom: 16px;\n\n        @media screen and (max-width: 781px) {\n          margin-bottom: 12px;\n        }\n\n        span {\n          color: var(--font-color);\n          font-family: Red Hat Display;\n          font-size: 15px;\n          font-style: normal;\n          font-weight: 700;\n          line-height: normal;\n        }\n\n        .left_rate {\n          width: auto;\n          height: 24px;\n          background: var(--re-rate-bg);\n          border-radius: 8px;\n          display: flex;\n          margin-left: auto;\n          padding: 4px 3.27px 4px 4px;\n          align-items: center;\n          gap: 4px;\n\n          span {\n            color: #ff6a55;\n            font-family: Red Hat Display;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: 16px;\n            letter-spacing: -0.15px;\n          }\n        }\n      }\n\n      .today {\n        color: #7c7c7d;\n        font-family: Red Hat Display;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: normal;\n      }\n\n      .capacity {\n        color: var(--font-color);\n        font-family: Red Hat Display;\n        font-size: 36px;\n        font-style: normal;\n        font-weight: 700;\n        line-height: normal;\n\n        @media screen and (max-width: 781px) {\n          font-size: 26px;\n        }\n      }\n    }\n  }\n\n  .horizontal {\n    width: 100%;\n    height: 1px;\n    background-color: var(--re-horizontal-bg);\n    margin-top: 19px;\n\n    @media screen and (max-width: 781px) {\n      display: none;\n    }\n  }\n\n  .proxy_container {\n    @media screen and (max-width: 781px) {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"analytics_container": `analytics_analytics_container__Ji8sF`,
	"plan": `analytics_plan__lge4N`,
	"bland": `analytics_bland__XEcb2`,
	"bland_icon": `analytics_bland_icon__lp6ZH`,
	"brand_title": `analytics_brand_title__MnhEz`,
	"brand_description": `analytics_brand_description__YgAci`,
	"option": `analytics_option__hh3vd`,
	"brand_label": `analytics_brand_label__zZAWU`,
	"data_range": `analytics_data_range__VtiMA`,
	"footer": `analytics_footer__nMYQ0`,
	"label": `analytics_label__9Ejjt`,
	"data_value": `analytics_data_value__3x3Yc`,
	"data_left": `analytics_data_left__tpIRh`,
	"data_used": `analytics_data_used__z3fse`,
	"data_label": `analytics_data_label__-YCzC`,
	"left_rate": `analytics_left_rate__oPhGl`,
	"capacity": `analytics_capacity__DbDXO`,
	"progress": `analytics_progress__20+nb`,
	"today": `analytics_today__om66y`,
	"horizontal": `analytics_horizontal__vyJz4`,
	"proxy_container": `analytics_proxy_container__I2E-2`
};
export default ___CSS_LOADER_EXPORT___;
